import { StoreScopedIntentBuilder } from './StoreScopedIntentBuilder';

/** Post unlock: store + the post identified by id or permalink slug. */
export class PostIntentBuilder extends StoreScopedIntentBuilder {
  /** Post id (`stores/:store_id/posts/:post_id`). */
  postId(postId: string): this {
    this.root.param('post_id', postId);
    return this;
  }

  /** Full post permalink (`urlCode/post/year/month/slug`). */
  postSlug(postSlug: string): this {
    this.root.param('post_slug', postSlug);
    return this;
  }
}
